import React, { useState } from 'react';
import { Modal, Input, Button, Form, Typography, Image } from 'antd';
import IconPasswordOn from 'assets/images/login/IconPasswordOn.svg';
import IconPasswordOff from 'assets/images/login/IconPasswordOff.svg';
import Pass_success from 'assets/images/login/pass_success.svg';
import Pass_failed from 'assets/images/login/pass_failed.svg';
import { resetPassword } from './helper';
import { auth } from 'firebase';

interface Props {
    visible: boolean;
    onClose: () => void;
    dataUser: any;
    notification: any;
}

const UpdatePasswordModal: React.FC<Props> = ({ visible, onClose, dataUser, notification }) => {
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [viewPwd, setViewPwd] = useState(false);
    const [viewConfirm, setViewConfirm] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState<{ password?: string; confirm?: string; user?: string }>({});

    const userIdent = dataUser?.usuario || '';

    const validate = () => {
        const err: any = {};
        if (!userIdent) err.user = 'Usuario no registrado.';
        if (!password) err.password = 'Campo requerido';
        else if (password.length < 10) err.password = 'Mínimo 10 caracteres';
        if (!confirm) err.confirm = 'Campo requerido';
        else if (confirm !== password) err.confirm = 'Las contraseñas no coinciden';
        if (password && confirm && password !== confirm) err.password = 'Las contraseñas no coinciden';
        return err;
    };

    const handleReset = async () => {
        setSubmitted(true);
        const err = validate();
        setErrors(err);
        if (Object.keys(err).length > 0) return;
        setLoading(true);
        try {
            // await apiResetPassword({ userIdent, password });
            const body = {

                "userId": dataUser?.p_id,
                password: password


            }
            const res = await resetPassword(body, {
                Authorization: 'Bearer ' + dataUser?.token
            });
            setSuccess(true);
            notification.success({ message: 'Contraseña actualizada exitosamente' });
        } catch (error: any) {
            notification.error({ message: 'Error', description: error?.response?.data?.message || 'No fue posible actualizar la contraseña.' });
        } finally {
            setLoading(false);
        }
    };

    const handleReady = () => {
        setSuccess(false);
        setPassword('');
        setConfirm('');
        onClose();
    };

    return (
        <Modal
            open={visible}
            onCancel={onClose}
            footer={null}
            title={null}
            destroyOnClose
            maskClosable={false}
            centered
            width={400}
            bodyStyle={{ padding: '32px 24px 18px 24px', borderRadius: 12 }}
        >
            {success ? (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginBottom: 24,
                    gap: 12,
                    padding:24
               }}>
                    <Image
                        src={Pass_success}
                        alt="success"
                        preview={false}
                        style={{ width: 64, height: 64 }}
                    />  
                    <Typography.Title level={4} style={{ fontWeight: 400, fontSize: 22, color: '#747474', marginBottom: 24, marginTop: 0, textAlign: 'center' }}>
                        Contraseña actualizada correctamente. Ahora puedes iniciar sesión.
                    </Typography.Title>
                    <Button type="primary" onClick={handleReady} style={{ marginTop: 20, width: '100%', background: '#cb9214', border: 0, fontWeight: 600 }}>
                        Listo
                    </Button>
                </div>
            ) : (
                <>
               <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginBottom: 24,
                    gap: 12
               }}>
                 <Image
                        src={Pass_failed}
                        alt="fail"
                        preview={false}
                        style={{ width: 64, height: 64 }}
                    />  
                    <Typography.Title level={4} style={{ fontWeight: 400, fontSize: 22, color: '#747474', marginBottom: 24, marginTop: 0, textAlign: 'center' }}>
                        Tu contraseña ha vencido, debes actualizarla para continuar.
                    </Typography.Title>
               </div>
                    <Form layout="vertical">
                        <Form.Item
                            label={<span style={{ color: "#727272", fontWeight: 400 }}>Usuario</span>}
                            style={{ marginBottom: 18 }}
                        >
                            <Input
                                value={userIdent}
                                disabled
                                readOnly
                                style={{
                                    borderRadius: 8,
                                    fontWeight: 400,
                                    background: '#fff',
                                    color: '#5a5a5a',
                                    height: 40,
                                    fontSize: 15,
                                    width: '100%'
                                }}
                            />
                            {submitted && errors.user && (
                                <Typography.Text type="danger" style={{ fontSize: 13, marginTop: 3, display: 'block' }}>
                                    {errors.user}
                                </Typography.Text>
                            )}
                        </Form.Item>
                        <Form.Item
                            label={<span style={{ color: "#727272", fontWeight: 400 }}>Nueva contraseña</span>}
                            style={{ marginBottom: 18 }}
                        >
                            <Input
                                type={viewPwd ? 'text' : 'password'}
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                autoComplete="new-password"
                                placeholder="Escriba nueva contraseña"
                                style={{
                                    borderRadius: 8,
                                    fontWeight: 400,
                                    height: 40,
                                    fontSize: 15,
                                    paddingRight: 35,
                                    width: '100%'
                                }}
                                suffix={
                                    <img
                                        src={viewPwd ? IconPasswordOn : IconPasswordOff}
                                        alt="Ver/Ocultar"
                                        onClick={() => setViewPwd(v => !v)}
                                        style={{ cursor: 'pointer', width: 22, height: 22, opacity: 0.62, marginRight: 4 }}
                                    />
                                }
                            />
                            {submitted && errors.password && (
                                <Typography.Text type="danger" style={{ fontSize: 13, marginTop: 3, display: 'block' }}>
                                    {errors.password}
                                </Typography.Text>
                            )}
                        </Form.Item>
                        <Form.Item
                            label={<span style={{ color: "#727272", fontWeight: 400 }}>Confirmar nueva contraseña</span>}
                            style={{ marginBottom: 26 }}
                        >
                            <Input
                                type={viewConfirm ? 'text' : 'password'}
                                value={confirm}
                                onChange={e => setConfirm(e.target.value)}
                                autoComplete="new-password"
                                placeholder="Confirme nueva contraseña"
                                style={{
                                    borderRadius: 8,
                                    fontWeight: 400,
                                    height: 40,
                                    fontSize: 15,
                                    paddingRight: 35
                                }}
                                suffix={
                                    <img
                                        src={viewConfirm ? IconPasswordOn : IconPasswordOff}
                                        alt="Ver/Ocultar"
                                        onClick={() => setViewConfirm(v => !v)}
                                        style={{ cursor: 'pointer', width: 22, height: 22, opacity: 0.62, marginRight: 4 }}
                                    />
                                }
                            />
                            {(submitted && errors.confirm) && (
                                <Typography.Text type="danger" style={{ fontSize: 13, marginTop: 3, display: 'block' }}>
                                    {errors.confirm}
                                </Typography.Text>
                            )}
                        </Form.Item>
                        <div style={{ display: 'flex', gap: 12 }}>
                            <Button
                                onClick={onClose}
                                style={{
                                    flex: 1,
                                    background: '#111',
                                    color: '#fff',
                                    fontWeight: 700,
                                    height: 40,
                                    borderRadius: 6,
                                    border: 0,
                                    fontSize: 16,
                                    letterSpacing: 0.2,
                                }}
                            >
                                Cancelar
                            </Button>
                            <Button
                                type="primary"
                                loading={loading}
                                onClick={handleReset}
                                style={{
                                    flex: 1,
                                    background: '#cb9214',
                                    color: '#171717',
                                    fontWeight: 700,
                                    height: 40,
                                    borderRadius: 6,
                                    border: 0,
                                    fontSize: 16,
                                    letterSpacing: 0.2,
                                    boxShadow: 'none'
                                }}
                            >
                                Restablecer
                            </Button>
                        </div>
                    </Form>
                </>
            )}
        </Modal>
    );
};

export default UpdatePasswordModal;